module.exports = __webpack_public_path__ + "img/background.5f77cfe3.jpg";